export default __webpack_public_path__ + "static/media/1317.c4c91bee.png";